// models/produtos/combos/Conjunto.js
export class Conjunto {
    constructor({id = 0, nome = '', qtdMin = 0, qtdMax = 0, obrigaSel=false, conjuntoGeraQtd = false, defineValorItem = false, items = []} = {}) {
        this.id = id;
        this.nome = nome;
        this.qtdMin = qtdMin;
        this.qtdMax = qtdMax;
        this.obrigaSel = obrigaSel;
        this.conjuntoGeraQtd = conjuntoGeraQtd;
        this.defineValorItem = defineValorItem;
        this.items = items; // Lista de ConjuntoItem
    }
}
